export default __webpack_public_path__ + "static/media/68.369b6dbc.jpg";